import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { handleErrorToast } from "../CustomFunctions";
function OfficeBillingstats({ loading = false, onClick, setIsOverflowing = () => { }, expanded = false, isOverflowing = false, year, month }) {

    const containerRef = useRef(null);
    const [data, setData] = useState([]);
    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current) {
                const container = containerRef.current;
                const firstRowBottom = container.children[0]?.offsetTop + container.children[0]?.offsetHeight;
                let overflowing = false;
                for (let i = 1; i < container.children.length; i++) {
                    if (container.children[i].offsetTop > firstRowBottom) {
                        overflowing = true;
                        break;
                    }
                }
                setIsOverflowing(overflowing);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [data]);

    const getLettersstats = async () => {

        try {
            // const res = await axios.get(`${BASE_URL}/siteproject/LetterAssignmentStats/`);
            const res = await axios.get(`${BASE_URL}/siteproject/officerentfilterStats/${month}/${year}/`);
            setData(res.data);



        } catch (error) {
            handleErrorToast(error);
        } finally {
            // SetbufferProject(false)
        }
    };

    useEffect(() => {

        getLettersstats();
    }, [year, month])

    return (
        <div>
            <div
                className={`statusbar-con ${expanded ? "expanded" : "collapsed"}`}
                ref={containerRef}
            >

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Total
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.total ?? 0}</label>
                    )}
                </div>

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Approved
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.approved ?? 0}</label>
                    )}
                </div>

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Pending
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.pending ?? 0}</label>
                    )}
                </div>

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Rejected
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.rejected ?? 0}</label>
                    )}
                </div>

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Pending BY checker
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.pending_by_role?.Checker ?? 0}</label>
                    )}
                </div>
                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Pending BY Account
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.pending_by_role?.Account ?? 0}</label>
                    )}
                </div>

                <div
                    key={`${data.title}`}
                    className="status-card"
                    onClick={onClick ? () => onClick(data.value) : null}
                >
                    <label className="status-title">
                        Pending BY Authority
                    </label>
                    {loading ? (
                        <div className="spinner-vsmall" />
                    ) : (
                        <label className="status-label">{data.pending_by_role?.AuthorityEngineer ?? 0}</label>
                    )}
                </div>


            </div>
        </div>
    );
}

export default OfficeBillingstats;
